import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import type { ReactNode } from 'react';
interface LinkItemProps {
  itemId: number;
  children: ReactNode;
  className?: string;
}

/**
 * LinkItem component for linking to item detail pages
 * Wraps content with a Next.js Link to /items/[id]
 */
export function LinkItem(t0) {
  const $ = _c(4);
  const {
    itemId,
    children,
    className
  } = t0;
  const t1 = `/items/${itemId}`;
  let t2;
  if ($[0] !== children || $[1] !== className || $[2] !== t1) {
    t2 = <Link href={t1} className={className}>{children}</Link>;
    $[0] = children;
    $[1] = className;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}